import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { inject, observer } from 'mobx-react';
import BaseGridXL from '../common/grid/BaseGridXL';
import styled from '@emotion/styled';
import EditCell from '../common/grid/EditCell';
import { PharmacyAnnualReview } from '../../store/models/PharmacyAnnualReview';
import { IconNames } from '@blueprintjs/icons';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { Div } from 'glamorous';
import { Button, Classes, Dialog, Intent, InputGroup, RadioGroup, Radio } from '@blueprintjs/core';
import { Form } from 'react-final-form';
import { TextInputFormField } from '../common/form';
import { PharmacyAnnualReviewSearchCriteria } from '../../store/PharmacyAnnualReviewStore';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { PharmacyAnnualReviewStore } from '../../store';
interface AnnualReviewManagerProps extends WithTranslateProps {
  annualReviews: Array<Instance<typeof PharmacyAnnualReview>>;
  onReviewSave: (data: Instance<typeof PharmacyAnnualReview>) => void;
  searchCriteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>;
  onSearch: (criteria: any) => void;
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
  filter: string;
  setFilterText: (filter: string) => void;
  PharmacyAnnualReviewStore?: Instance<typeof PharmacyAnnualReviewStore>;
  secretariatId?: number | undefined;
}

interface AnnualReviewManagerState {
  annualReviewEdition?: Instance<typeof PharmacyAnnualReview>;
  annualReviewIsLoading?: boolean;
  year?: number;
  width?: number;
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerSearchForm = styled.div`
  display: flex;
  flex-direction: row;
`;
const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;
const DivCenter = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 5px;
  .bp3-form-content > div {
    display: flex;
    flex-direction: row;
    margin-right: 20px;
    .bp3-control {
      margin-top: 0;
      margin-right: 5px;
    }
  }
  .bp3-form-group {
    margin-bottom: 0;
  }
`;

@inject('PharmacyAnnualReviewStore')
@observer
class AnnualReviewManager extends React.Component<AnnualReviewManagerProps, AnnualReviewManagerState> {
  state = {
    systemStatusEdition: undefined,
    annualReviewIsLoading: false,
    year: 0,
    width: 90,
  } as AnnualReviewManagerState;

  _isMounted = false;

  columns = [
    { headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_Year), field: 'year', sort: 'desc', width: 60 },
    {
      headerName: this.props.translate(TLCode.PHARMACY_Level),
      field: 'level',
      suppressMenu: true,
      width: 35,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_ApbNr),
      field: 'pharmacyApbNumber',
      suppressMenu: true,
      width: 75,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY),
      field: 'pharmacyName',
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDutyCount),
      field: 'actualDutyCount',
      width: 70,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDutyCount),
      field: 'averageDutyCount',
      width: 70,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Balance),
      field: 'approvedBalance',
      width: 70,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsBalance),
      field: 'absBalance',
      width: 70,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Ratio),
      field: 'ratio',
      width: 75,
      hide: true,
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_PrevActualDayDutyCount),
      field: 'prevActualDayDutyCount',
      width: this.state.width,
      cellStyle: { 'background-color': '#f9f998' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDayDutyCount),
      field: 'actualDayDutyCount',
      width: this.state.width,
      cellStyle: { 'background-color': '#f9f998' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDayDutyCount),
      field: 'averageDayDutyCount',
      width: this.state.width,
      cellStyle: { 'background-color': '#f9f998' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_DayBalance),
      field: 'approvedDayBalance',
      width: this.state.width,
      cellStyle: { 'background-color': '#f9f998' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsDayBalance),
      field: 'absDayBalance',
      width: this.state.width,
      cellStyle: { 'background-color': '#f9f998' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_DayRatio),
      field: 'dayRatio',
      width: this.state.width,
      cellStyle: { 'background-color': '#f9f998' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualNightDutyCount),
      field: 'actualNightDutyCount',
      width: this.state.width,
      cellStyle: { 'background-color': '#eaeae8' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageNightDutyCount),
      field: 'averageNightDutyCount',
      width: this.state.width,
      cellStyle: { 'background-color': '#eaeae8' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_NightBalance),
      field: 'approvedNightBalance',
      width: this.state.width,
      cellStyle: { 'background-color': '#eaeae8' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AbsNightBalance),
      field: 'absNightBalance',
      width: this.state.width,
      cellStyle: { 'background-color': '#eaeae8' },
    },
    {
      headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_NightRatio),
      field: 'nightRatio',
      width: this.state.width,
      cellStyle: { 'background-color': '#eaeae8' },
    },
    { headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_Status), field: 'status', width: 90 },
    {
      width: 90,
      headerName: '',
      sortable: false,
      filter: false,
      cellRendererFramework: EditCell,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          onEditButtonClick: () => {
            this.startEdition(params.data.pharmacyAnnualReviewId);
          },
        };
      },
    },
  ] as ColDef[];

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  buildGridData = () => {
    const { activeFilter } = this.props;
    return this.props.annualReviews
      .filter(
        (ar) =>
          this.props.secretariatId === undefined ||
          ar.pharmacy === undefined ||
          ar.pharmacy!.secretariatId === this.props.secretariatId,
      )
      .map((ss) => ({
        ...ss,
        pharmacyApbNumber: ss.pharmacy ? ss.pharmacy.apbNumber : '',
        pharmacyName: ss.pharmacy ? ss.pharmacy.name : '',
        level: ss.pharmacy ? ss.pharmacy.level : '',
        absBalance: ss.approvedBalance ? Math.abs(ss.approvedBalance!) : '',
        absDayBalance: ss.approvedDayBalance ? Math.abs(ss.approvedDayBalance!) : '',
        ratio: ss.actualDutyCount && ss.actualDutyCount > 0 ? ss.actualDutyCount / ss.averageDutyCount! : '',
        dayRatio:
          ss.actualDayDutyCount && ss.actualDayDutyCount > 0 ? ss.actualDayDutyCount / ss.averageDayDutyCount! : '',
        nightRatio:
          ss.actualNightDutyCount && ss.actualNightDutyCount > 0
            ? ss.actualNightDutyCount / ss.averageNightDutyCount!
            : '',
        absNightBalance: ss.approvedNightBalance ? Math.abs(ss.approvedNightBalance!) : '',
      }));
  };

  startEdition = (id: number) => {
    const annualReview = this.props.annualReviews.find((elem) => elem.pharmacyAnnualReviewId === id);
    this.setState({ annualReviewEdition: annualReview });
  };

  stopEdition = () => {
    this.setState({ annualReviewEdition: undefined });
  };

  save = (data: any) => {
    this.props.onReviewSave(data);
    this.stopEdition();
  };

  handleCalculate = () => {};

  onChangeYear = (data) => {
    this.setState({ year: data });
  };

  calculateAnnualReviews = async () => {
    this._isMounted && this.setState({ annualReviewIsLoading: true });
    await this.props.PharmacyAnnualReviewStore!.generateAnnualReview(
      this.props.secretariatId === undefined ? 0 : this.props.secretariatId!,
      this.state.year!,
    );
    this._isMounted && this.setState({ annualReviewIsLoading: false });
  };

  onChangeStatusCriterion = (data) => {
    this.props.searchCriteria.status = data;
    this.props.setActiveFilter(data);
  };

  render() {
    const { annualReviewEdition } = this.state;
    const { setFilterText, filter, setActiveFilter, activeFilter, translate } = this.props;
    return (
      <Container>
        <Form onSubmit={this.props.onSearch} initialValues={this.props.searchCriteria}>
          {({ handleSubmit, mutators, initialize }) => (
            <div>
              <ContainerSearchForm>
                <TextInputFormField
                  // style={{ marginLeft: '5px', marginRight: '5px' }}
                  name={'year'}
                  label={TLCode.SECRETARIAT_DASHBOARD_Year}
                  inline={true}
                />
                &nbsp;&nbsp;&nbsp;
                {/* <CheckboxInputFormField
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                  name={'validated'}
                  label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validated}
                  inline={true}
                /> */}
                <DivLine>
                  <DivCenter>
                    <SimpleTextFormContent label={TLCode.SECRETARIAT_DASHBOARD_Status}>
                      <RadioGroup
                        selectedValue={activeFilter}
                        onChange={(data) => this.onChangeStatusCriterion(data.currentTarget.value)}
                      >
                        <Radio
                          key={'Calculated'}
                          label={translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Calculated)}
                          value="Calculated"
                          alignIndicator="right"
                        />
                        &nbsp;&nbsp;&nbsp;
                        <Radio
                          key={'Validated'}
                          label={translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validated)}
                          value="Validated"
                          alignIndicator="right"
                        />
                        &nbsp;&nbsp;&nbsp;
                        <Radio
                          key={'All'}
                          label={translate(TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_All)}
                          value="both"
                          alignIndicator="right"
                        />
                        &nbsp;&nbsp;&nbsp;
                      </RadioGroup>
                    </SimpleTextFormContent>
                  </DivCenter>
                </DivLine>
                &nbsp;&nbsp;
                <div style={{ marginLeft: '20px' }}>
                  <Button intent="primary" icon={IconNames.SEARCH} onClick={() => handleSubmit()}>
                    <TranslatedMessage id={TLCode.GENERAL_Search} />
                  </Button>
                </div>
                &nbsp;&nbsp;
                <InputGroup placeholder="Year to review..." onChange={(e) => this.onChangeYear(e.target.value)} />
                <div style={{ marginLeft: '20px' }}>
                  <Button intent="primary" icon={IconNames.CALCULATOR} onClick={this.calculateAnnualReviews}>
                    <TranslatedMessage id={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Calculate} />
                  </Button>
                </div>
                {/* <DivCenter>
              <SimpleTextFormContent label={TLCode.PHARMACIES_ActivityStatus}>
                <RadioGroup selectedValue={activeFilter} onChange={(data) => setActiveFilter(data.currentTarget.value)}>
                  <Radio key={'active'} label={translate(TLCode.PHARMACIES_Active)} value="active" />
                  <Radio key={'inactive'} label={translate(TLCode.PHARMACIES_Inactive)} value="inactive" />
                  <Radio key={'both'} label={translate(TLCode.PHARMACIES_All)} value="both" />
                </RadioGroup>
              </SimpleTextFormContent>
              </DivCenter> */}
              </ContainerSearchForm>
              <DivLine>
                <DivLeft>
                  <InputGroup
                    placeholder="Filter..."
                    leftIcon="search"
                    value={filter}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </DivLeft>
              </DivLine>
            </div>
          )}
        </Form>
        <BaseGridXL
          columnDefs={this.columns}
          rowData={this.buildGridData()}
          keyName={'pharmacyAnnualReviewId'}
          quickFilterText={filter}
        />
        <Dialog
          isOpen={annualReviewEdition !== undefined}
          onClose={this.stopEdition}
          icon={IconNames.EDIT}
          title={<TranslatedMessage id={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate} />}
          canOutsideClickClose={false}
        >
          {annualReviewEdition && (
            <Div>
              <div className={Classes.DIALOG_BODY}>
                <Form
                  initialValues={annualReviewEdition}
                  onSubmit={this.save}
                  render={({ handleSubmit, hasValidationErrors, dirty }) => {
                    return (
                      <form onSubmit={handleSubmit}>
                        <TextInputFormField
                          name="actualDutyCount"
                          label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDutyCount}
                          inline={true}
                          fill={true}
                          disabled={true}
                        />
                        <TextInputFormField
                          name="averageDutyCount"
                          label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDutyCount}
                          inline={true}
                          fill={true}
                          disabled={true}
                        />
                        <TextInputFormField
                          name="approvedBalance"
                          label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Balance}
                          inline={true}
                          required={true}
                          fill={true}
                          autoFocus={true}
                        />
                        <div className={Classes.DIALOG_FOOTER}>
                          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button
                              text={<TranslatedMessage id={TLCode.GENERAL_Cancel} />}
                              onClick={this.stopEdition}
                            />
                            <Button
                              type="submit"
                              intent={Intent.PRIMARY}
                              disabled={hasValidationErrors}
                              text={<TranslatedMessage id={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate} />}
                            />
                          </div>
                        </div>
                      </form>
                    );
                  }}
                />
              </div>
            </Div>
          )}
        </Dialog>
      </Container>
    );
  }
}

export default withTranslate(AnnualReviewManager);
